import React from 'react';
import WarningIcon from '@material-ui/icons/Warning';
import Alert from 'react-bootstrap/Alert';
import Spinner from 'react-bootstrap/Spinner';
import {Button} from '@material-ui/core';
import numeral from 'numeral';
import {Popover} from 'react-bootstrap';

import SPUtilities from '../util/SPUtilities';
import Utilities from '../util/Utilities';
import RespUtils from '../util/RespUtils';

import CopyAddress from "../base/CopyAddress";
import SPCalc from '../util/SPCalc';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import config from '../config';
import constants from "../constants";

class IUtils extends React.Component {

  static calcPercent(input1, input2) {
    // console.info("getStakeWeight - ", poolStake, totalStake);
    if (input2 == undefined || input2 == 0) {
      return "";
    }

    if (input1 == undefined || input1 == 0) {
      return 0;
    }

    return (input1 * 100 /input2).toFixed(2) + "%";
  }


  static websiteLink(label, link) {
    if (!label) {
      return label;
    }

    if (!link) {
      return label;
    }

    return (<a className="black-a" target="_blank"
      href={SPUtilities.getUrl(link)}>{label}</a>);
  }

  static addressFormatter(cell, row, index, formatExtraData) {
    return IUtils.addressFormatterByType(cell, true, false);
  }

  static addressFormatterDel(cell, row, index, formatExtraData) {
    return IUtils.addressFormatterByType(cell, true, false);
  }

  static addressFormatterLong(cell, row, index, formatExtraData) {
    return IUtils.addressFormatterByType(cell, false, false);
  }

  static addressFormatterByType(address, short, validator) {
    if (!address) {
      return "";
    }

    let label = "";
    if (short) {
      label = SPUtilities.addressLabelShortFormatter(address, null, short);
    } else {
      label = address;
    }

    let link = "https://iotexscan.io/address/";
    let target = "_blank";
    if(validator) {
      link = "https://stake.iotex.io/delegate/";
    }

    return (<span><a className="black-a" target={target}
      href={link + address}>{label}</a></span>);
  }

  static delegateIdFormatter(id, row) {
    if (!id) {
      return "";
    }

    let target = "_blank";
    let link = "https://stake.iotex.io/delegate/";

    return (<span><a className="black-a" target={target}
      href={link + row.registeredName}>{id}</a></span>);
  }

  static addressFormatterByLabel(cell, row) {
    return IUtils.addressFormatterLabelShortInd(cell, row, false);
  }

  static addressFormatterByLabelShort(cell, row) {
    return IUtils.addressFormatterLabelShortInd(cell, row, true);
  }

  static addressFormatterLabelShortInd(cell, row, short) {
    if (!cell) {
      return "";
    }

    let shortInd = short;
    if (!shortInd) {
      shortInd = (window.innerWidth > 1000 ? false : true);
    }

    let label = row.alias;
    if (!row.alias) {
      label = SPUtilities.addressLabelShortFormatter(cell, null, shortInd);
    }

    let link = "/address/";

    return (<span><a className="black-a"
      href={link + row.address}>{label}</a>
      &nbsp;{IUtils.copyLink(row.address)}</span>);
  }

  static getNameLabel(cell) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");

    if (label.length > 20) {
      label = label.substring(0, 18) + "..";
    }

    return label;
  }

  static nameFormatterNoLink(cell) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");
    return label;
    // return IUtils.getNameLabel(cell);
  }

  static nameFormatter(cell, row, extra) {
    if (!cell) {
      return "";
    }

    let label = IUtils.getNameLabel(cell) + IUtils.getNameLabelSuffix(cell, row, extra);

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a className="black-a" href={"/delegate/" + row.delegateId}
      >{label}</a></span>);
  }

  static getNameLabelSuffix(cell, row, extra) {
    let suffix = "";
    // if (extra && extra != 'false') {
    //   if (row.hermesInd === '0') {
    //     suffix = "*";
    //   }
    // }

    return suffix;
  }

  static nameFormatterShort(cell, row, index, extra) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");

    if (window.innerWidth < 1000 && label.length > 8) {
      label = label.substring(0, 6) + ".";
    }

    label += IUtils.getNameLabelSuffix(cell, row, extra);

    const onClick = e => e.stopPropagation();

    return (<span onClick={ onClick }><a className="black-a" href={"/delegate/" + row.delegateId}
      >{label}</a></span>);
  }

  static nameFormatterLong(cell, row) {
    if (!cell) {
      return "";
    }

    let label = cell.split("?").join("");
    label += IUtils.getNameLabelSuffix(cell, row, "true");

    return (<span><a className="black-a" href={"/delegate/" + row.delegateId}
      >{label}</a></span>);
  }

  static replaceAll(value, search, replace) {
    return value.split(search).join(replace);
  }

  static copyLink(address) {
    // let widthNHeight = 16;
    // if (window.innerWidth < 600) {
    //   widthNHeight = 16;
    // }

    // let imgSrc = "/images/copy.png";
    // let title = "Copy address to clipboard"
    // console.log("copied: ", formatExtraData.state.copied);
    // if (row.address == formatExtraData.state.copied) {
    //   imgSrc = "/images/check-circle-outline.png";
    //   title = "Copied address to clipboard"
    // }

    // return (<CopyToClipboard text={address}
    //     onCopy={() => {
    //       // formatExtraData.setState({copied: row.address});
    //       // console.log(row.address);
    //       // return false;
    //       <DisappearingMessage />
    //     }}>
    //     <img src={imgSrc} title={title}
    //       className="imgicon" width={16} height={16} />
    //   </CopyToClipboard>);
    return (<CopyAddress address={address} />)
  }

  static addressLabelShortFormatter(value, row, short) {
    if (!value) {
      return value;
    }

    let label = value;
    if (short || (window.innerWidth < 1400 && value.length > 10)) {
      if (window.innerWidth < 600) {
        label = value.substring(0,6) + "..";
      } else {
        label = value.substring(0,10) + "..";
      }
    }

    return label;
  }

  static statusFormatter(cell, row, index, extra) {
    let color = "green";

    if (!cell || cell == 'NotEligible') {
      color = "red";
    } else if (cell == 'Eligible' || cell == 'Elected' || cell == 'InConsensus') {
      color = "green";
    } else {
      color = "orange";
    }

    let value = cell;
    if (RespUtils.isMobileView()) {
      let statusDescSmall = {"InConsensus": "Cons", "Elected": "Elec", "Eligible": "Elig", "NotEligible": "Not El", "Probated": "Prob"}
      // value = value.substring(0, 4);
      value = statusDescSmall[value];
    } else {
      let statusDesc = {"InConsensus": "In Consensus", "Elected": "Elected", "Eligible": "Eligible", "NotEligible": "Not Eligible", "Probated": "Probated"}
      value = statusDesc[value];
    }

    return IUtils.colorFormatter(value, color, row.risky);
  }

  static colorFormatter(value, color, risky) {
    let size = "8";
    if (window.innerWidth > 1000) {
      size = 16;
    }

    let imgSrc = "/images/" + color + "-" + size + ".png"
    if (risky === 'True') {
      return (<span title="Check delegate details before deciding to vote for this delegate"><img src={imgSrc} /> <WarningIcon /> {value}</span>)
    }

    return (<span><img src={imgSrc} /> {value}</span>)
  }

  static coinCountCellFormatter(cell, row) {
    if (!cell) {
      return cell;
    }

    return SPCalc.formatCoinCount(cell.toFixed(0));
  }

  static convertPercentFormatter(cell, row) {
    if (!cell) {
      if (cell == 0) {
        return (window.innerWidth > constants.MEDIUM) ? "0 %" : "0";
      }
      return cell;
    }

    let value = cell
    if (cell > 0) {
      var formattedNumber = (cell * 100).toFixed(2).replace(/[.,]00$/, "");
      value = formattedNumber;
      // let percentVal = cell * 100;
      // return (percentVal.toFixed(2) + "%");
    }

    if (window.innerWidth > constants.MEDIUM) {
      return value + " %";
    }

    return value
  }

  static percentFormatter(cell, row) {
    // console.log(cell);
    if (!cell) {
      if (cell == 0) {
        return (window.innerWidth > constants.MEDIUM) ? "0 %" : "0";
      }
      return cell;
    }

    let value = cell;
    if (cell > 0) {
      // console.log((typeof cell), " - in percentFormatter: ", cell);
      var formattedNumber = (cell).toFixed(2).replace(/[.,]00$/, "");
      value = formattedNumber;
    }

    if (window.innerWidth > constants.MEDIUM) {
      return value + " %";
    }

    return value

  }

  static formatBigCoinCount(count) {
    if (window.innerWidth < constants.MEDIUM) {
      return SPUtilities.stakeFormatterRounded(count);
    } else {
      return SPCalc.formatCoinCount(count);
    }
  }

  static logoFormatter(cell, row) {
    let url = "images/logo/" + row.address + ".png";
    // let logoPath = cell;
    // if (row.type == 'SOLO') {
    //   url = null;
    //   logoPath = "images/logo/solo.png"
    // }
    return IUtils.logoFormatterFlex(url, false);
  }

  static logoFormatterFlex(logoPath, large) {
    // console.log(logoPath)
    if (!logoPath) {
      return logoPath;
    }

    let size = 16;

    if (large && window.innerWidth < 1000) {
      size = 32;
    } else if (large) {
      size = 32;
    } else if (window.innerWidth > 1000) {
      size=20;
    }

    return "";
    // return (<object type="image/png"
    //    width={size} height={size} data={logoPath}>
    //     <img width={size} height={size} src="images/logo/blank.jpg" />
    // </object>);

    // return (<a href={url} target="_blank"><img width="32" height="32"
    //   src={"https://tools.aionsmartstake.com/" + cell}
    //   onerror="this.src='oasis-logo.svg'" /></a>);
  }

  static showCurrentReturns(value, row) {
    // console.log((row.status == 'Elected'), !value);
    if (row.status == 'Elected' && !value) {
      return "N/A";
    }

    return value;
  }

  static lifetimeSignPer(cell, row) {
    return IUtils.calcPercent(cell, row.lifetimeToSign)
  }

  static addressLink(value) {
    if (!value) {
      return value;
    }

    return (<a href={"https://iotexscan.io/address/" + value}
      class="black-a" target="_blank">IoTeX Explorer</a>);
  }

  static rewardsLink(value) {
    if (!value) {
      return value;
    }

    return (<a href={"/rewards/" + value}
      class="black-a">Rewards History</a>);
  }

  static getSupportUs() {
    return (<Alert variant="info">Like Smart Stake tools? Support us by voting with Smart Stake &nbsp;
      <a href="https://stake.iotex.io/delegate/smartstake"
       className="black-a" target="_blank">here</a>.</Alert>)
  }

  static getFee(cell, row, index, extraData) {
    if (Utilities.isNaN(cell)) return "";
    // console.log(cell + " - " + row.feeChangedEpoch + " - " + row.feeChangedDesc + " - " + extraData);
    // if (row.feeChangedEpoch != null && row.feeChangedEpoch + 7 > extraData) {
    //   return (<span style={{"backgroundColor": "orange"}}>{row.feeChangedDesc}</span>);
    // }

    return IUtils.percentFormatter((100-cell), row);
  }

  static getRewardShare(cell, row, index, extraData) {
    if (Utilities.isNaN(cell)) return "";

    return IUtils.percentFormatter((cell), row);
  }

  static renderEventTypes(thisObj) {
    if (RespUtils.isMobileView()) {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId}>All</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Delegate"}>Del</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Undelegate"}>Undel</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/EditValidator"}>Validator</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Fee_Increase"}>Fee +</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Fee_Decrease"}>Fee -</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/large"}>Large</a></td>
        </tr></tbody></table></div>);
    } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId}>All</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Delegate"}>Delegate</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Undelegate"}>Undelegate</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/EditValidator"}>EditValidator</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Fee_Increase"}>Fee Increase</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/Fee_Decrease"}>Fee Decrease</a></td>
          <td className="view-tag"><a href={"/events/" + thisObj.state.val.delegateId + "/large"}>Large</a></td>
        </tr></tbody></table></div>);
    }
  }

  static renderNetworkEventTypes() {
    // if (window.innerWidth < 600) {
    //   return (<div><table><tbody><tr>
    //       <td className="view-tag"><a href={"/networkEvents"}>All</a> </td>
    //       <td className="view-tag"><a href={"/networkEvents/Add_Escrow"}>Add Escrow</a></td>
    //       <td className="view-tag"><a href={"/networkEvents/Reclaim_Escrow"}>Reclaim Escrow</a></td>
    //       <td className="view-tag"><a href={"/networkEvents/Transfer"}>Transfer</a></td>
    //       <td className="view-tag"><a href={"/networkEvents/Received"}>Received</a></td>
    //     </tr></tbody></table></div>);
    // } else {
      return (<div><table><tbody><tr>
          <td className="view-tag"><a href={"/networkEvents"}>All</a></td>
          <td className="view-tag"><a href={"/networkEvents/Delegate"}>Delegate</a></td>
          <td className="view-tag"><a href={"/networkEvents/Undelegate"}>Undelegate</a></td>
          <td className="view-tag"><a href={"/networkEvents/CollectRewards"}>Rewards</a></td>
          <td className="view-tag"><a href={"/networkEvents/EditValidator"}>EditValidator</a></td>
          <td className="view-tag"><a href={"/networkEvents/Fee_Increase"}>Fee Increase</a></td>
          <td className="view-tag"><a href={"/networkEvents/Fee_Decrease"}>Fee Decrease</a></td>
          <td className="view-tag"><a href={"/networkEvents/large"}>Large</a></td>
        </tr></tbody></table></div>);
    // }
  }

  static getSmartStakeMsg(smartStakeInd) {
    // console.log("this.props.smartStake : ", this.props.smartStake);
    if (smartStakeInd != null && smartStakeInd === false) {
      return (IUtils.getSupportUs())
    }

    return "";
  }

  static formatEventType(cell) {
    if (!cell || !RespUtils.isMobileView()) {
      return cell;
    }

    if (cell === 'CollectRewards') {
      return "Rewards";
    } else if (cell === 'EditValidator') {
      return "EditVal";
    } else if (cell === 'Undelegate') {
      return "Undel";
    } else if (cell === 'Delegate') {
      return "Del";
    }

    return cell;
  }


  static convert2DigitsDecimal(cell, row) {
    if (!cell) {
      return cell;
    }

    let value = cell
    if (cell > 0) {
      value = (cell).toFixed(2).replace(/[.,]00$/, "");
    }

    return value
  }

  static productivityFormatter(cell, row) {
    if (Utilities.isNaN(cell)) return "";

    if (!row.productivityBase) return "";

    // return <span><Spinner animation="grow" size="sm"/> {cell}/30</span>;
    return <span>{cell}/{row.productivityBase}</span>;
  }

  static rewardsFormatter(cell, row, rowIndex, extra) {
    if (extra && extra == 'false') return "N/A";

    if (!cell) return "";

    if (cell === '1') {
      return "Auto";
    }

    return "Manual";
  }

  static getDelegateId(thisObj) {
    let delegateId;

    if (thisObj.props.match) {
      delegateId = thisObj.props.match.params.delegateId;
    }

    if (!delegateId && thisObj.props.delegateId) {
      delegateId = thisObj.props.delegateId;
    }

    if (!delegateId) {
      delegateId = config.apiGateway.DEFAULT_POOL_ID;
    }

    return delegateId;
  }

  static getFeeInSync(value) {
      if (value === "True") {
        return <span><font color="red">No</font></span>;
      }

      return "Yes";
  }

  static getRiskyInd(risky) {
    if (risky === 'True') {
      return (<span title="Check delegate details before deciding to vote for this delegate"><WarningIcon /></span>);
    }

    return "";
  }

  static takeToVote(cell, row) {
    window.open("https://stake.iotex.io/delegate/" + row.registeredName);
  }

  // static getExistingVotesLink(delId) {
  //   return (<span><a className="black-a" target="_blank" href={"https://stake.iotex.io/delegate/" + delId + "/my-votes"}>View Votes</a></span>);
  // }

  static voteFormatterLarge(key) {
    return (<span><a href={"https://stake.iotex.io/delegate/" + key}
      target="_blank"><button className="button-special-large" id={"Vote" + key}
      >Vote</button></a></span>);
  }

  static voteFormatter(cell, row) {
    if (!cell) return "";

    const onClick = e => e.stopPropagation();
    return (<span onClick={ onClick }><a href={"https://stake.iotex.io/delegate/" + row.registeredName}
      target="_blank"><button className="button-special" id={"Vote" + cell}
      >Vote</button></a></span>);
  }

  static getBadge(badgeInd, imgSrc, title) {
    if (badgeInd === "1") {
      return <span title={title}><img src={imgSrc} title={title}
            className="imgicon" width={24} height={24} />&nbsp;</span>
    }

    return "";
  }

  // backgroundImage: "linear-gradient(to right, rgba(3, 179, 178, 0.1), rgba(27, 221, 164, 0))"
  static consensusStyleFormatter(cell, row, index, extra) {
    if (!cell) return "";

    if (cell <= 36) {
      return {"background-image": "linear-gradient(to right, #00b4a0, #ffffff)"};
    } else {
      return {"background-image": "linear-gradient(to right, rgb(245, 167, 30), #ffffff)"};
    }
  }

  static getProdIndexRating(index) {
    let rating = `Production Index ${index} for the delegate is good. `;
    if (index < 0.75) {
      rating = `Production Index ${index} for the delegate is very low. `;
    } else if (index < 0.95) {
      rating = `Production Index ${index} for the delegate is below average. `;
    }

    return rating;
  }
}

export default IUtils;



// WEBPACK FOOTER //
// ./src/iotex/IUtils.js